import React, { useEffect, useState } from "react";
import { MdInfoOutline } from "react-icons/md";
import ColoredBadge from "./Badge/ColoredBadge";
import { Tooltip } from "@chakra-ui/react";

const ProductSet2 = ({
  product,
  variantId,
  productSet,
  setProductSet,
  selectedItems,
  setSelectedItems,
  selectedItemBasePrice,
  setSelectedItemBasePrice,
  totalPrice,
  totalbasePrice,
  allowRingSize,
  setAllowRingSize,
  allowAnkletType,
  setAllowAnkletType,
  isPair,
  setIsPair,
  allowBraceletSize,
  setAllowBraceletSize,
  styleBox = true,
}) => {

  const handleSetSelection = (
    setID,
    sku,
    itemPrice,
    itemBasePrice,
    isChecked
  ) => {
    setSelectedItems((prev) => {
      if (isChecked) {
        return [...prev, { itemPrice, sku }];
      } else {
        return prev.filter((price) => price.itemPrice !== itemPrice);
      }
    });

    setSelectedItemBasePrice((prev) => {
      if (isChecked) {
        return [...prev, { itemBasePrice, sku }];
      } else {
        return prev.filter(
          (basePrice) => basePrice.itemBasePrice !== itemBasePrice
        );
      }
    });

    if (productSet.length > 0) {
      // if(productSet.length)

      if (productSet.some((item) => item === setID)) {
        if (sku.toUpperCase().includes("SAIR")) {
          setAllowRingSize(false);
        }

        if (sku.toUpperCase().includes("SAIA")) {
          setAllowAnkletType(false);
          setIsPair(false);
        }
        if (sku.toUpperCase().includes("SAIB")) {
          setAllowBraceletSize(false);
        }
        setProductSet((prev) => {
          let prevArr = prev.filter((val) => val !== setID);
          // console.log("im in remove", prevArr);

          return prevArr;
        });
      } else {
        if (sku.toUpperCase().includes("SAIR")) {
          setAllowRingSize(true);
        }

        if (sku.toUpperCase().includes("SAIA")) {
          setAllowAnkletType(true);
        }

        if (sku.toUpperCase().includes("SAIB")) {
          setAllowBraceletSize(true);
        }
        setProductSet((prev) => {
          let prevArr = [...prev];

          prevArr.push(setID);
          // console.log("im in new add", prevArr);

          return prevArr;
        });
      }
    } else {
      setProductSet((prev) => {
        let prevArr = [...prev];

        prevArr.push(setID);
        // console.log("im in fresh add", prevArr);

        return prevArr;
      });

      if (sku.toUpperCase().includes("SAIR")) {
        setAllowRingSize(true);
      }

      if (sku.toUpperCase().includes("SAIA")) {
        setAllowAnkletType(true);
      }

      if (sku.toUpperCase().includes("SAIB")) {
        setAllowBraceletSize(true);
      }
    }
  };

  useEffect(() => {
    if (productSet.length === product.products.length) {
      setProductSet([]);
      setSelectedItems([]);
      setSelectedItemBasePrice([]);
      setAllowRingSize(false);
      setAllowAnkletType(false);
      setAllowBraceletSize(false);
      setIsPair(false);
      //  console.log('Disable');
    }
  }, [productSet]);

  // console.log("productSet", productSet);

  return (
    <>
      <div className="">
        <div className="flex flex-col  gap-2">
          <div className="flex items-center gap-2">
            <label htmlFor="quantitySelect">Customized Jewellery Set:</label>
            <Tooltip label="Choose at least two items to build your perfect jewelry set." hasArrow placement="top" bg="#000080" color="white">
              <span>
                <MdInfoOutline className="text-[19px] text-zinc-400 cursor-pointer" />
              </span>
            </Tooltip>
          </div>
          {/* <p className="text-[14px] text-red-500">
                                {productSetError}
                              </p> */}
        </div>
        <div className={`grid grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-4 pt-4`}>
          {/* {product?.products?.map((item) => ( */}
          {Array.isArray(product?.products) &&
            !product.products.some((item) => typeof item === "string") &&
            product.products.map((item) => (
              <div className="flex justify-start items-center gap-3">
                <div
                  className={`w-full flex flex-col  min-h-[233px] gap-2 justify-between items-center ${productSet.some((val) => val === item._id)
                    ? "border-2 border-[#000080]"
                    : "border border-zinc-300"
                    } hover:shadow-lg transition duration-300 ease-in-out  p-2`}
                  onClick={() =>
                    handleSetSelection(
                      item._id,
                      item.sku,
                      item.price,
                      item.basePrice,
                      !productSet.some((val) => val === item._id)
                    )
                  }
                >
                  <div
                    className={`w-full flex flex-col gap-1 justify-center items-center`}
                  >
                    <img
                      src={
                        item.variants?.find((vari) => {
                          // Find the variant that matches the selected variantId
                          const selectedVariant = product.variants?.find(
                            (variant) => variant._id === variantId
                          );

                          if (
                            selectedVariant &&
                            selectedVariant.color === vari.color
                          ) {
                            return true; // Return the matching variant
                          }

                          return false; // If no match, return false
                        })?.images[0]
                      }
                      alt={item.name}
                      className={`w-[100px]`}
                    />

                    <div
                      className="w-full 
flex flex-col gap-2 "
                    >
                      <h1
                        className={`uppercase text-[12px] min-h-[40px] flex justify-center items-center text-center ${productSet.some((val) => val === item._id)
                          ? "text-[#000080]"
                          : ""
                          } transition duration-300 ease-in-out`}
                      >
                        {item.name}
                      </h1>
                      <div className="flex justify-center items-center gap-1">
                        {item.sku.includes("SAIA") ? (
                          <>
                            <h1 className="text-[12px] text-center md:text-[14px] font-bold text-gray-900">
                              <span>
                                ₹{" "}
                                {isPair
                                  ? (item.price * 2)?.toLocaleString("en-IN")
                                  : item.price?.toLocaleString("en-IN")}
                              </span>
                            </h1>
                            <p className="inline-block p-1 text-[10px] line-through text-gray-400">
                              {" "}
                              <span>
                                {" "}
                                ₹{" "}
                                {isPair
                                  ? (item.basePrice * 2)?.toLocaleString(
                                    "en-IN"
                                  )
                                  : item.basePrice?.toLocaleString("en-IN")}
                              </span>
                            </p>
                            {isPair && (
                              <ColoredBadge
                                text={"x2 PAIR"}
                                bgColor={"bg-[#000080]"}
                                textColor={"text-white"}
                                className={"rounded-sm "}
                              />
                            )}
                          </>
                        ) : (
                          <>
                            <h1 className="text-[12px] text-center md:text-[14px] font-bold text-gray-900">
                              <span>
                                ₹ {item.price?.toLocaleString("en-IN")}
                              </span>
                            </h1>
                            <p className="inline-block p-1 text-[10px] line-through text-gray-400">
                              {" "}
                              <span>
                                ₹ {item.basePrice?.toLocaleString("en-IN")}
                              </span>
                            </p>
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  {productSet.some((val) => val === item._id) && (
                    <div>
                      <input
                        type="checkbox"
                        name={item._id}
                        value={item._id}
                        className="rounded-full text-[#000080]"
                        checked={
                          productSet.some((val) => val === item._id)
                          // ,
                          // selectedItems.includes(item.price)
                        }
                        // disabled={product?.products.length === productSet?.length}
                        onChange={(e) =>
                          handleSetSelection(
                            item._id,
                            item.sku,
                            item.price,
                            item.basePrice,
                            e.target.checked
                          )
                        }
                      />
                    </div>
                  )}
                </div>
              </div>
            ))}
        </div>
        {/* {selectedItems.length > 0 && (<div className="flex flex-row items-center gap-2 pt-4">
          <label
            className="flex items-center gap-[5px] text-[14px] md:text-[16px]"
            htmlFor="quantitySelect"
          >
            Total Amount{" "}
            :
          </label>
          <h1 className=" text-[14px] text-center md:text-[16px] font-bold text-gray-900">
            ₹ {totalPrice.toLocaleString("en-IN")}
          </h1>
          <h1 className="text-[10px] line-through text-gray-400">
            ₹ {totalbasePrice.toLocaleString("en-IN")}
          </h1>
        </div>)} */}
        {selectedItems.length > 0 && (
          <div className="flex flex-row items-center gap-2 pt-4">
            <label
              className="flex items-center gap-[5px] text-[14px] md:text-[16px]"
              htmlFor="quantitySelect"
            >
              Total Amount{" "}
              {product.setItemsPer > 0 && (<span
                className={`${selectedItems.length < 2 ? "hidden" : "block"
                  } text-[#000080]`}
              >
                (Extra {(product.setItemsPer * (selectedItems.length - 1))}% Discount)
              </span>)}
              :
            </label>
            <h1 className=" text-[14px] text-center md:text-[16px] font-bold text-gray-900">
              ₹ {totalPrice.toLocaleString("en-IN")}
            </h1>
            <h1 className="text-[10px] line-through text-gray-400">
              ₹ {totalbasePrice.toLocaleString("en-IN")}
            </h1>
          </div>
        )}
      </div>
    </>
  );
};

export default ProductSet2;
